import DOMPurify from "dompurify";
import { cn } from "@/lib/utils";

const ALLOWED_TAGS = [
  "p", "br", "strong", "b", "em", "i", "u", "s", "ul", "ol", "li",
  "h2", "h3", "span", "div",
];
const ALLOWED_ATTR = ["style", "class"];

function looksLikeHtml(value) {
  return /<\/?[a-z][\s\S]*>/i.test(value || "");
}

function escapePlain(text) {
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\n/g, "<br>");
}

/** Renders stored rich-text HTML (or plain text) with design-friendly prose styles. */
export default function RichText({ html, className, as: Tag = "div", light = false }) {
  if (html == null || html === "") return null;

  const raw = looksLikeHtml(html) ? html : `<p>${escapePlain(html)}</p>`;
  const clean = DOMPurify.sanitize(raw, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    // Keep inline color / font-family / alignment from the editor
    ADD_ATTR: ["style"],
  });

  return (
    <Tag
      className={cn(
        "rich-text",
        light ? "rich-text--light" : "rich-text--dark",
        className
      )}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
